
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://kigjogeefpheyxdubzye.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImtpZ2pvZ2VlZnBoZXl4ZHVienllIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDMxODI0MzQsImV4cCI6MjA1ODc1ODQzNH0.RBwdl_5NEyRceT_RzILa6UNtaGeQSwT9v9p_3jimkwk";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);
